import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';
import { getStore } from '@core/store';
import { serializer } from './serializer';

bus.on(constants.EVENTS.APP.READY, refreshAppData);
bus.on(constants.EVENTS.APP_DATA.REFRESH, refreshAppData);

bus.on(constants.EVENTS.APP_DATA.UPDATE, saveAppData);
bus.on(constants.EVENTS.APP_DATA.UPDATE_GENERAL, saveAppData);
bus.on(constants.EVENTS.APP_DATA.UPDATE_CONTACTS, saveAppData);
bus.on(constants.EVENTS.APP_DATA.UPDATE_RATES, saveAppData);
bus.on(constants.EVENTS.APP_DATA.UPDATE_USSD, saveAppData);
bus.on(constants.EVENTS.APP_DATA.UPDATE_ADDRESSES, saveAppData);
bus.on(constants.EVENTS.APP_DATA.UPDATE_APPLINKS, saveAppData);
bus.on(constants.EVENTS.APP_DATA.UPDATE_PAYMENT_PROVIDERS, saveAppData);
bus.on(constants.EVENTS.APP_DATA.UPDATE_MANUAL_OPERATIONS, saveAppData);

function refreshAppData() {
  const requestId = `appdata-${Date.now()}`;
  bus.emit(EVENTS.APP_DATA.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${constants.ENDPOINTS.APP_DATA.GET}`,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(EVENTS.APP_DATA.REFRESHED, parsed.data);
      } else {
        bus.emit(EVENTS.APP_DATA.REFRESH_ERROR, parsed);
      }
    }
  });
}

function fetchFreshData() {
  return new Promise((resolve, reject) => {
    const requestId = `fetchFresh-${Date.now()}`;
    const timeout = setTimeout(() => reject(new Error('Timeout lors de la récupération des données')), 30000);

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: requestId,
      url: constants.ENDPOINTS.APP_DATA.GET,
      method: 'GET',
      data: {}
    });

    const handler = (res) => {
      if (res.id === requestId) {
        clearTimeout(timeout);
        bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
        const parsed = serializer.deserialize(res);
        if (parsed.success) {
          resolve(parsed.data);
        } else {
          reject(new Error(parsed.message || 'Erreur lors de la récupération des données'));
        }
      }
    };

    bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
  });
}

function sendUpdateRequest(data) {
  return new Promise((resolve, reject) => {
    const requestId = `saveAppData-${Date.now()}`;
    const timeout = setTimeout(() => reject(new Error('Timeout lors de la mise à jour')), 30000);

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: requestId,
      url: constants.ENDPOINTS.APP_DATA.UPDATE,
      method: 'POST',
      data: data
    });

    const handler = (res) => {
      if (res.id === requestId) {
        clearTimeout(timeout);
        bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
        const parsed = serializer.deserialize(res);
        if (parsed.success) {
          resolve(parsed.data);
        } else {
          reject(new Error(parsed.message || 'Erreur lors de la mise à jour'));
        }
      }
    };

    bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
  });
}

async function saveAppData(data) {
  bus.emit(constants.EVENTS.LOADING.START);

  try {
    // 1. Récupérer les données fraîches du serveur
    const freshData = await fetchFreshData();

    // 2. Fusionner avec les nouvelles données
    const mergedData = serializer.serialize(data, freshData);

    // 3. Envoyer au serveur
    const result = await sendUpdateRequest(mergedData);

    bus.emit(constants.EVENTS.LOADING.FINISH);
    bus.emit(constants.EVENTS.APP_DATA.UPDATED, result);
    bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
      title: 'Succès',
      body: 'Données mises à jour avec succès'
    });

    refreshAppData();
  } catch (error) {
    bus.emit(constants.EVENTS.LOADING.FINISH);
    bus.emit(constants.EVENTS.APP_DATA.UPDATE_FAILED, { message: error.message });
    bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
      title: 'Erreur',
      body: error.message || 'Erreur lors de la mise à jour'
    });
  }
}
